export default "__VITE_ASSET__U7FB4Eco__"